import script from "./PaywallCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaywallCTA.vue?vue&type=script&setup=true&lang=ts"

import "./PaywallCTA.vue?vue&type=style&index=0&id=61383044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61383044"]])

export default __exports__